export default "__VITE_ASSET__BaB$Co3C__"